import React, { useEffect, useState } from "react";
import CancelledTakeAway from "./OrdersTable/cancelled/CancelledTakeAway";
import CancelledDinein from "./OrdersTable/cancelled/CancelledDinein";

function CompletedCancelationnTable({ selectTitle, orderType, orderData, refresh }) {
  const [orderTakeAwayData, setOrderTakeAwayData] = useState([]);
  const [orderDineInData, setOrderDineInData] = useState([]);

  useEffect(() => {
    setOrderTakeAwayData(
      orderData.filter((order) => order.orderType === "Takeaway")
    );
    setOrderDineInData(
      orderData.filter((order) => order.orderType === "Dine-in")
    );
  }, [orderData, orderType, selectTitle]);

  return (
    <div className="tablesOrder">
      {selectTitle === "Completed" ? (
        orderType === "TakeAway" ? (
          <CancelledTakeAway items={orderTakeAwayData} status={"Completed"} />
        ) : (
          <CancelledDinein items={orderDineInData} status={"Completed"} />
        )
      ) : selectTitle === "Cancelled" ? (
        orderType === "TakeAway" ? (
          <CancelledTakeAway items={orderTakeAwayData} status={"Cancelled"} />
        ) : (
          <CancelledDinein items={orderDineInData} status={"Cancelled"} />
        )
      ) : selectTitle === "No Show" ? (
        orderType === "TakeAway" ? (
          <CancelledTakeAway items={orderTakeAwayData} status={"No-Show"} refresh={refresh} />
        ) : (
          <CancelledDinein items={orderDineInData} status={"No-Show"} refresh={refresh} />
        )
      ) : null}
    </div>
  );
}
export default CompletedCancelationnTable;
